import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70 shadow-[0_1px_3px_rgba(0,0,0,0.3)]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
              <span className="text-background-50 font-bold text-lg font-heading">90</span>
            </div>
            <span className="text-xl font-bold text-foreground-50 font-heading group-hover:text-primary-400 transition-colors">
              90影视
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-400 bg-primary-500/10'
                  : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/60'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  location.pathname.includes(cat.slug)
                    ? 'text-primary-400 bg-primary-500/10'
                    : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/60'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-400 bg-primary-500/10'
                  : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/60'
              }`}
            >
              关于我们
            </Link>
          </nav>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-300 hover:text-foreground-50 hover:bg-background-200/60 transition-all cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? '关闭菜单' : '打开菜单'}
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-b border-background-200/70">
          <nav className="max-w-[1400px] mx-auto px-4 py-4 flex flex-col gap-1" aria-label="移动端导航">
            <Link
              to="/"
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                location.pathname === '/' ? 'text-primary-400 bg-primary-500/10' : 'text-foreground-300 hover:bg-background-200/60'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                  location.pathname.includes(cat.slug) ? 'text-primary-400 bg-primary-500/10' : 'text-foreground-300 hover:bg-background-200/60'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                location.pathname === '/about' ? 'text-primary-400 bg-primary-500/10' : 'text-foreground-300 hover:bg-background-200/60'
              }`}
            >
              关于我们
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}